module.exports = __webpack_public_path__ + "static/media/dominik-jirovsky-749482-unsplash.e27f3509.jpg";